import { CircleInfoIcon } from "@xola/icons";
import { Alert } from "@xola/ui-kit";
import React from "react";
import { LineItemType, PaymentMethod, Purchase, SellerPaymentMethod } from "types";
import { useSeller } from "../../../hooks/useAccount";
import { isOnFlexSubscription } from "../../../models/PartnerFeeFormula";

interface RefundToStoreCreditWarningProps {
    paymentMethod: SellerPaymentMethod | null;
    purchase: Purchase;
}

export const RefundToStoreCreditWarning = ({ paymentMethod, purchase }: RefundToStoreCreditWarningProps) => {
    const seller = useSeller();
    const isStoreCredit = paymentMethod?.id === PaymentMethod.STORE_CREDIT;
    const partnerFeeItem = purchase.lineItems.find((item) => item.type === LineItemType.PARTNER_FEE);
    const partnerFeeAmount = partnerFeeItem?.amount === 0 ? partnerFeeItem.collected : partnerFeeItem?.amount;

    if (isStoreCredit && isOnFlexSubscription(seller) && partnerFeeAmount) {
        return (
            <Alert>
                <div className="flex w-full items-center space-x-4">
                    <div>
                        <CircleInfoIcon size="large" />
                    </div>

                    <p>
                        The Service Fee of <var data-var="partnerFeeAmount">${partnerFeeAmount}</var> cannot be refunded
                        to Store Credit. The guest will not be double charged the Service Fee when using the store
                        credit.
                    </p>
                </div>
            </Alert>
        );
    }

    return null;
};
